module.exports = __webpack_public_path__ + "img/card-refundedDJ.6ca08a05.svg";